import React from "react";
import {
	Box,
	Container,
	Grid,
	TextField,
	Typography,
	Button,
} from "@mui/material";
import Page from "../../../components/Page";
import { useNavigate } from "react-router-dom";
import { Formik } from "formik";
import * as Yup from "yup";
import { createEscola } from "../../../database/API";
import { useSnackbar } from "notistack";
import Title from "../../../components/Title";
import Thumb from "../../../components/Thumb";
import { MuiColorInput } from "mui-color-input";
import { styled } from "@mui/material";

const EscolesAdd = () => {
	const navigate = useNavigate();
	const { enqueueSnackbar } = useSnackbar();

	const crear = async (values) => {
		const message = await createEscola(values);
		enqueueSnackbar(message, {
			variant: "success",
		});
		navigate(-1, { state: values });
	};

	return (
		<Page title={"Dashboard"}>
			<Container maxWidth={false}>
				<Formik
					initialValues={{
						nom: "",
						color: "#ffffff",
						color_alt: "#ffffff",
						imatge: "",
					}}
					validationSchema={Yup.object().shape({
						nom: Yup.string().required("El nom és obligatòri"),
					})}
					onSubmit={(values) => {
						crear(values);
					}}
				>
					{({
						errors,
						handleBlur,
						handleChange,
						handleSubmit,
						isSubmitting,
						setFieldValue,
						touched,
						values,
					}) => (
						<form onSubmit={handleSubmit}>
							<Box mb={3}>
								<Title
									title={"Crear escola"}
									subtitle={
										"Entra les dades per guardar una nova escola"
									}
								/>
							</Box>
							<Grid container spacing={3}>
								<Grid item size={6}>
									<TextField
										error={Boolean(
											touched.nom && errors.nom
										)}
										fullWidth
										helperText={touched.nom && errors.nom}
										label="Nom"
										margin="normal"
										variant="outlined"
										name="nom"
										onBlur={handleBlur}
										onChange={handleChange}
										type="text"
										value={values.nom}
									/>
								</Grid>
								<Grid item size={3}>
									<Typography variant="body1">
										Color
									</Typography>
									<Box mt={1} />
									<MuiColorInput
										onChange={(value) => {
											setFieldValue("color", value);
										}}
										value={values.color}
										label="Color"
										name="color"
									/>
								</Grid>

								<Grid item size={3}>
									<Typography variant="body1">
										Color alternatiu
									</Typography>
									<Box mt={1} />
									<MuiColorInput
										onChange={(value) => {
											setFieldValue("color_alt", value);
										}}
										value={values.color}
										label="Color alternatiu"
										name="color_alt"
									/>
								</Grid>
							</Grid>

							<Grid container spacing={3}>
								<Grid item size={12}>
									<Box mt={2}>
										<Typography>Imatge</Typography>
										<input
											id="imatge"
											name="imatge[]"
											type="file"
											onChange={(event) => {
												setFieldValue(
													"imatge",
													event.currentTarget.files[0]
												);
											}}
											className="form-control"
										/>
									</Box>
									<Box p={2}>
										<Thumb file={values.imatge} />
									</Box>
								</Grid>
							</Grid>

							<Box my={2}>
								<Button
									color="primary"
									fullWidth
									size="large"
									type="submit"
									variant="contained"
								>
									{"Crear"}
								</Button>
							</Box>
						</form>
					)}
				</Formik>
			</Container>
		</Page>
	);
};

export default EscolesAdd;
